import { Drawer as MuiDrawer, type DrawerProps as MuiDrawerProps } from '@mui/material';

export type DrawerProps = MuiDrawerProps;

export const Drawer = (props: Readonly<DrawerProps>) => <MuiDrawer {...props} />;
